import { useMemo } from 'react';

import { Status } from '#/components/Status/Status';
import { Errors } from '#/errors/errors';
import { OneError } from '#/errors/oneError';
import { useConfig } from '#/hooks/useConfig';
import { PageDefaultContext } from '#/pages/pageTypes';
import { AppStatus } from '#/service/constants';

import { PageController } from '../PageController';

export const HomePage = () => {
  const { pages } = useConfig();
  const defaultContext: PageDefaultContext = useMemo(() => ({}), []);

  const homePageId = pages.HOME;

  if (!homePageId) {
    return (
      <Status
        error={new OneError(Errors.CONFIGURATION_GENERAL_MISSING_PAGE)}
        status={AppStatus.Error}
      />
    );
  }

  return <PageController defaultContext={defaultContext} pageId={homePageId} />;
};
